document.documentElement.classList.remove('no-js');

function initComparisons(root = document) {
  root.querySelectorAll('[data-compare]').forEach((compare) => {
    if (compare.dataset.ready) return;
    compare.dataset.ready = 'true';
    const after = compare.querySelector('[data-compare-after]');
    const line = compare.querySelector('[data-compare-line]');
    let dragging = false;
    const setValue = (value) => {
      const next = Math.max(2, Math.min(98, value));
      after.style.clipPath = `inset(0 0 0 ${next}%)`;
      line.style.left = `${next}%`;
      compare.setAttribute('aria-valuenow', Math.round(next));
    };
    const fromPointer = (event) => {
      const bounds = compare.getBoundingClientRect();
      setValue(((event.clientX - bounds.left) / bounds.width) * 100);
    };
    compare.addEventListener('pointerdown', (event) => { dragging = true; compare.setPointerCapture(event.pointerId); fromPointer(event); });
    compare.addEventListener('pointermove', (event) => { if (dragging) fromPointer(event); });
    compare.addEventListener('pointerup', (event) => { dragging = false; if (compare.hasPointerCapture(event.pointerId)) compare.releasePointerCapture(event.pointerId); });
    compare.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const current = Number(compare.getAttribute('aria-valuenow')) || 50;
      setValue(current + (event.key === 'ArrowRight' ? 5 : -5));
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initComparisons());
document.addEventListener('shopify:section:load', (event) => initComparisons(event.target));
